/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
/**
* Enum class NftType.
* @enum {}
* @readonly
*/
export default class NftType {
    
        /**
         * value: 1
         * @const
         */
        "1" = 1;

    
        /**
         * value: 2
         * @const
         */
        "2" = 2;

    
        /**
         * value: 4
         * @const
         */
        "4" = 4;

    
        /**
         * value: 8
         * @const
         */
        "8" = 8;

    

    /**
    * Returns a <code>NftType</code> enum value from a Javascript object name.
    * @param {Object} data The plain JavaScript object containing the name of the enum value.
    * @return {module:model/NftType} The enum <code>NftType</code> value.
    */
    static constructFromObject(object) {
        return object;
    }
}

